export default __webpack_public_path__ + "a31643f61b860fc65e05b9f823ab4ef0.png";